import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid, MenuItem } from "@mui/material";
import { useFormContext } from "react-hook-form";

import CustomTextField from "../../../../components/CustomTextField";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import axios from "../../../../utils/axios";

function MaterialFields(props) {
  const { t } = useTranslation();
  const { fields } = props;

  const {
    formState: { errors },
    control,
  } = useFormContext();

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get("/material-categories/active");
        setCategories(response.data);
      } catch (err) {
        console.error("Failed to fetch categories", err);
      }
    };
    fetchCategories();
  }, []);

  return (
    <Grid container spacing={6} className="row">
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("material_code")}
          name="materialCode"
          control={control}
          fullWidth
          variant="outlined"
          fields={fields}
          errors={errors}
          disabled={true}
          helperText="Auto-generated on save based on Category"
        />
      </Grid>

      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("material_name")}
          name="materialName"
          control={control}
          fullWidth
          variant="outlined"
          fields={fields}
          errors={errors}
        />
      </Grid>

      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="categoryId"
          label={t("category")}
          control={control}
          fullWidth
          variant="outlined"
          fields={fields}
          errors={errors}
        >
          {categories.map((cat) => (
            <MenuItem key={cat.categoryId} value={cat.categoryId}>
              {cat.categoryName}
            </MenuItem>
          ))}
        </ReactHookFormSelect>
      </Grid>

      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("brand")}
          name="brand"
          control={control}
          fullWidth
          variant="outlined"
          fields={fields}
          errors={errors}
        />
      </Grid>

      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("model")}
          name="model"
          control={control}
          fullWidth
          variant="outlined"
          fields={fields}
          errors={errors}
        />
      </Grid>

      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("unit_of_measurement")}
          name="uom"
          control={control}
          fullWidth
          variant="outlined"
          fields={fields}
          errors={errors}
        />
      </Grid>

      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("minimum_stock")}
          name="minimumStock"
          control={control}
          fullWidth
          type="number"
          variant="outlined"
          fields={fields}
          errors={errors}
          InputProps={{ inputProps: { min: 0, step: 1 } }}
        />
      </Grid>

      <Grid item xs={12}>
        <CustomTextField
          label={t("description")}
          name="description"
          control={control}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          fields={fields}
          errors={errors}
        />
      </Grid>

      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="status"
          label={t("status")}
          control={control}
          fullWidth
          variant="outlined"
          fields={fields}
          errors={errors}
        >
          <MenuItem value="ACTIVE">ACTIVE</MenuItem>
          <MenuItem value="INACTIVE">INACTIVE</MenuItem>
        </ReactHookFormSelect>
      </Grid>
    </Grid>
  );
}

export default MaterialFields;
